import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-medium text-gray-900" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "flex items-center mt-3 text-sm text-brand-600" }

import { 
		useI18n
	} from 'vue-i18n'

	
	const __default__ = { name: 'ResetPasswordSuccess' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const {t} = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('resetPassword.email')), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('resetPassword.instructions')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        class: "link",
        to: {name: 'Login'}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('resetPassword.returnToLoginScreen')), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})